import { z } from 'zod';

export const formSchema = z.object({
  ngay_hl: z.string().optional().nullable(),
  gia_nt2: z.coerce.number().min(0, 'Giá bán không hợp lệ'),
  thue_yn: z.boolean().default(false),
  status: z.string().optional().nullable()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ngay_hl: null,
  gia_nt2: 0,
  thue_yn: false,
  status: '1'
};
